export default __webpack_public_path__ + "static/media/VelozmenteOn.bff6150b.png";